import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { CURRENT_SEASON } from 'common/src/utils/definitions';

interface FilterStore {
  selectedSeason: string;
  setSelectedSeason: (season: string) => void;
  /** Division of the exporter the analyses are scoped to; null means all. */
  selectedDivisionId: number | null;
  setSelectedDivisionId: (divisionId: number | null) => void;
}

const useFilterStore = create<FilterStore>()(
  persist(
    (set) => ({
      // Solo aplica a sesiones sin estado persistido; quien ya eligió una
      // temporada la conserva.
      selectedSeason: CURRENT_SEASON,
      setSelectedSeason: (season) => set({ selectedSeason: season }),
      selectedDivisionId: null,
      setSelectedDivisionId: (divisionId) =>
        set({ selectedDivisionId: divisionId }),
    }),
    {
      name: 'filter-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

/** Division the analyses are scoped to right now; null means all divisions. */
export const currentDivisionId = (): number | null =>
  useFilterStore.getState().selectedDivisionId;

export default useFilterStore;
